// extracted by mini-css-extract-plugin
export var resizer = "_el-0";